import { ChangeDetectionStrategy, Component, inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { GtmImportPack, provideOtpWarningServiceProvider } from '@partners/gtm';
import { SettingsMap } from '@partners/settings';
import {
  DialogContainerComponent,
  DialogIconDirective,
  DialogImportPack,
  FilledButtonComponent,
  LinkButtonComponent
} from '@partners/ui';
import { NavigationAdapter } from '../../navigation';
import { AlertIconComponent } from '../alert-icon/alert-icon.component';

@Component({
  standalone: true,
  imports: [FilledButtonComponent, DialogImportPack, LinkButtonComponent, AlertIconComponent, GtmImportPack],
  providers: [provideOtpWarningServiceProvider()],
  template: `
    <dialog-container #container gtmFunnelStepEvent="funnelStepEvent">
      <ng-template dialogIcon>
        <alert-icon data-alt="אייקון אילוסטרציה שגיאה" />
      </ng-template>


      <ng-template dialogTitle let-context><span>בטוח שהקלדת נכון?</span></ng-template>
      <ng-template dialogBody let-context>
        <div class="text-center">
          מזכירים שצריך למלא את הפרטים של כרטיס
          <span class="font--medium">כאל</span>
          או
          <span class="font--medium">דיינרס</span>
          שלך
        </div>
        <div class="mrg-tp-md mrg-bt-sm">
          <link-button decoration="arrow" (click)="moveToCardOwnerGuide()" gtmClickEvent="guideClickEvent">
            <span>כך נראה כרטיס כאל או דיינרס</span>
          </link-button>
        </div>
      </ng-template>
      <ng-template dialogFooter let-context>
        <div class="dialog-action">
          <filled-button (click)="hideDialog()" class="primary-action-button" gtmClickEvent="submitClickEvent">הבנתי, תודה</filled-button>
        </div>
      </ng-template>
    </dialog-container>
  `,
  styles: [],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OtpWarningComponent {
  @ViewChild('container', { static: true, read: DialogContainerComponent })
  dialogContainer: DialogContainerComponent;

  @ViewChild('dialogIcon', { static: true, read: DialogIconDirective })
  iconTemplate: DialogIconDirective;

  private _navAdapter = inject(NavigationAdapter);

  moveToCardOwnerGuide() {
    this.hideDialog();
    const { name } = SettingsMap.cardTypeGuide();
    this._navAdapter.moveTo(name);
  }

  hideDialog() {
    this.dialogContainer.dismissDialog(undefined);
  }
}
